import Wizard from '@components/Wizard/Wizard';
import { useState, useCallback } from 'react';
import Header from '@components/Header/Header';
import { StyledStepBar } from '@pages/LoginWallet/LoginWallet.styles';
import { Container } from './CreateWallet.styles';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';

// Import step components
import PINInputStep from './steps/PINInputStep';
import RecoveryPhraseStep from './steps/RecoveryPhraseStep';
import ReferralCodeStep from './steps/ReferralCodeStep';
import UserAgreementStep from './steps/UserAgreementStep';

const CreateWallet = () => {
  const navigate = useNavigate();
  const [currentWizardStep, setCurrentWizardStep] = useState(0);
  const { t } = useTranslation();
  const { resetInactivity } = useAuth();
  const [walletMnemonic, setWalletMnemonic] = useState<string>('');

  const steps = [
    {
      component: <PINInputStep setWalletMnemonic={setWalletMnemonic} />,
      title: t('page.createWallet.steps.pin.title')
    },
    {
      component: <RecoveryPhraseStep walletMnemonic={walletMnemonic} />,
      title: t('page.createWallet.steps.recoveryPhrase.title')
    },
    {
      component: <ReferralCodeStep />,
      title: t('page.createWallet.steps.referralCode.title')
    },
    {
      component: <UserAgreementStep />,
      title: t('page.createWallet.steps.userAgreement.title')
    },
  ];

  // Handle step change from the Wizard component
  const handleStepChange = useCallback((step: number) => {
    setCurrentWizardStep(step);
  }, []);

  const handleFinish = async () => {
    resetInactivity()
    navigate('/home');
  };

  return (
    <Container>
      <Header
        title={steps[currentWizardStep].title}
        showBackButton={true}
        onBackClick={() => window.history.back()}
      >
        <StyledStepBar steps={steps.length} currentStep={currentWizardStep + 1} />
      </Header>
      <Wizard
        steps={steps.map(step => step.component)}
        initialStep={currentWizardStep}
        onFinish={handleFinish}
        onStepChange={handleStepChange}
      />
    </Container>
  );
};

export default CreateWallet;
